import { __assign, __rest } from "tslib";
import * as React from 'react';
import { makeStyles, createStyles } from '../../styles';
import { Typography } from '../../Typography';
export var useStyles = makeStyles(function () {
    return createStyles({
        root: {
            pointerEvents: 'none',
        },
    });
});
export var SingleValue = function (props) {
    var option = props.option, other = __rest(props, ["option"]);
    var classes = useStyles();
    return (React.createElement(Typography, __assign({ component: "span", className: classes.root }, other), option.label));
};
export default SingleValue;
//# sourceMappingURL=Combobox.SingleValue.js.map